import { render, staticRenderFns } from "./MatchingCandidates.vue?vue&type=template&id=096fb030&scoped=true"
import script from "./MatchingCandidates.vue?vue&type=script&lang=ts"
export * from "./MatchingCandidates.vue?vue&type=script&lang=ts"
import style0 from "./MatchingCandidates.vue?vue&type=style&index=0&id=096fb030&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096fb030",
  null
  
)

export default component.exports